<template>
  <el-dialog
    :append-to-body="true"
    :title="$t('receivablePayable.tips')"
    :visible.sync="isBool"
    width="50%"
  >
    <div style="height: 40vh;overflow: hidden;">
      <div style="height: 100%;overflow: auto;">
        <!--付款单号生成成功！-->
        <div style="margin-bottom: 20px;">{{ $t('basicData.paymentNumberGeneratedSuccessfully') }}！</div>
        <!--付款单号：-->
        <div>{{ $t('receivablePayable.PaymentSlipNumber') }}：
          <div
            v-for="(item, index) in batchNumber"
            :key="index"
            style="margin: 0 10px 5px 0;"
          >
            <span>{{ item.replace('~', '\n') }}</span>
          </div>
        </div>
      </div>
      <textarea id="message5" />
    </div>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <!--取消-->
      <el-button size="small" @click="copyBatchNumber(1)">{{ $t('basicData.Cancel') }}</el-button>
      <!--复制单号-->
      <el-button
        size="small"
        type="primary"
        @click="copyBatchNumber(2)"
      >{{ $t('basicData.copyNumber') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      isBool: false,
      batchNumber: []
    };
  },

  methods: {
    open(list) {
      this.batchNumber = list;
      this.isBool = true;
    },

    // 复制
    async copyBatchNumber(type) {
      if (type === 1) {
        this.isBool = false;
        return false;
      }
      const num = this.batchNumber.map(item => item.split('~')[0]);
      const str = num.join(',');
      try {
        if (navigator.clipboard) {
          await navigator.clipboard.writeText(str); // 修改文本框的内容
          this.$message.success(this.$t('orderCenterCont.ReplicationSucceeded')); // '复制成功'
          this.isBool = false;
          this.$emit('change');
        } else {
          const textarea = document.createElement('textarea');
          try {
            textarea.style.position = 'fixed';
            textarea.style.left = '-9999px';
            textarea.value = str;

            document.body.appendChild(textarea);
            textarea.select(); // 选择对象
            document.execCommand('copy'); // 执行浏览器复制命令
            this.$message.success(this.$t('orderCenterCont.ReplicationSucceeded')); // '复制成功'
            this.isBool = false;
            this.$emit('change');
          } catch (error) {
            this.$message.warning(this.$t('GlobalSetObj.Lose'));
          } finally {
            document.body.removeChild(textarea);
          }
        }
      } catch (err) {
        console.log('浏览器不支持复制', err);
        this.$message.warning(this.$t('GlobalSetObj.Lose')); // '失败'
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
